import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'gen-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ToggleSwitchComponent {
  public status: boolean;
  @Output() statusUpdate: EventEmitter<boolean> = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() label: string;
  @Input() startPosition: boolean;
  @Input() textOnLeftSide = false;
  @Input() graphicMode: boolean = false;
  private initialChange = false;

  @Input()
  set active(active) {
    this.status = active;

    if (this.initialChange) {
      this.statusUpdate.emit(this.status);
    }
  }

  get active() {
    return this.status;
  }

  public toggle($event) {
    if (typeof($event) === 'object') {
      $event.stopPropagation();
    }

    this.initialChange = true;
    this.active = !this.status;
    this.initialChange = false;
  }
}
